<template>
  <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100vh;">
    <div class="card shadow-lg border border-secondary bg-dark text-white" style="width: 100%; max-width: 440px;">
      <div class="card-body">
        <h2 class="text-center mb-4">Login</h2>

        <form @submit.prevent="login">
          <div class="mb-3">
            <label for="secret_id" class="form-label">Secret ID</label>
            <input
              type="text"
              id="secret_id"
              class="form-control bg-secondary border-secondary text-light"
              v-model="secretId"
              required
            />
          </div>

          <div class="mb-3">
            <label for="secret_key" class="form-label">Secret Key</label>
            <input
              type="password"
              id="secret_key"
              class="form-control bg-secondary border-secondary text-light"
              v-model="secretKey"
              required
            />
          </div>

          <div class="mb-4">
            <label for="room_id" class="form-label">Room ID</label>
            <input
              type="text"
              id="room_id"
              class="form-control bg-secondary border-secondary text-light"
              v-model="roomId"
              required
            />
          </div>

          <button type="submit" class="btn btn-outline-light w-100">
            Sign In
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const secretId = ref('');
const secretKey = ref('');
const roomId = ref('');
const router = useRouter();
const route = useRoute();
const { appContext } = getCurrentInstance();

const login = () => {

  if (secretId.value && secretKey.value && roomId.value) {
    fetch("/api/users/me?room_id=" + roomId.value, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + btoa(secretId.value + ':' + secretKey.value)
      },
    }).then(response => {
        response.json().then(data => {
        if (!response.ok) {
          alert(data.detail);
        } else {
          console.log(data);
          localStorage.setItem('rtcrobotrole', data.role);
          localStorage.setItem('rtcrobotsecretid', secretId.value);
          localStorage.setItem('rtcrobotsecretkey', secretKey.value);
          localStorage.setItem('rtcrobotroomid', roomId.value);
          appContext.app.config.globalProperties.$USER.secretId = secretId.value;
          appContext.app.config.globalProperties.$USER.secretKey = secretKey.value;
          appContext.app.config.globalProperties.$USER.roomId = roomId.value;
          appContext.app.config.globalProperties.$USER.role = data.role;
          const redirect = route.query.redirect || '/';
          router.push(redirect);
        }
      });
    });
  } else {
    alert('All fields are required.');
  }
};

onMounted(() => {
});
</script>

<style scoped>
</style>

